import * as React from "react";
import * as moment from "moment";
import {
    CAR_PIU_PDF_PATH,
    CommonHelpers,
    DocTypeEnum,
    documentHelper,
    Policy,
} from "@ferry/journey-services";
import {resourcesHelper} from "@ferry/portal-core";
import {resolveClaimType, resolveFuelType, resolveTransmission} from "../../../../utils/resolveLookupValues";
import {formatDate, } from "../../../../CommonFunctions";
import {lazyInject} from "@athena-portal/core";
import {
    convertDate,
    getInteractionVehicleFuelType,
    getVehicleEngineSize,
    getVehicleNumberOfDoors
} from "@ferry/plugin-ferry-journey";
import {ListItem} from "@athena-portal/journey-model";
import {ILookupService, Types as JourneyCoreTypeDefs} from "@athena-portal/plugin-journey";

interface IProps {
    policy: Policy;
    currentlyActivePolicy?: Policy;
    vehicleIndex: number;
    isOldPolicy?: boolean;
}

interface IState {
    lookup: Record<string, ListItem[]>;
    documentPathToSizeMaps: Array<Map<string, string>>;
    carUsageName?: string;
}

export class YourDriveAwayCarCoverPanel extends React.Component<IProps, IState> {

    private readonly policyToRender: Policy;
    private readonly vehicleToRender: any;
    private readonly vehicleDrivers: any[] = [];

    @lazyInject(JourneyCoreTypeDefs.LookupService)
    private readonly lookupService: ILookupService;

    private readonly vehicles: any;

    constructor(props: IProps) {
        super(props);

        this.state = {
            lookup: {},
            documentPathToSizeMaps: [],
        };

        this.policyToRender = this.props.currentlyActivePolicy || this.props.policy;

        this.vehicles = this.policyToRender?.interaction.vehicles;

        this.vehicleToRender = this.policyToRender.interaction.vehicles[0];

        const allDrivers: any[] = [this.policyToRender.interaction.policyHolder].concat(this.policyToRender.interaction.additionalDrivers || []);
        if (this.vehicleToRender.driverIds) {
            this.vehicleDrivers = this.vehicleToRender.driverIds
                .map((driverId: string) => allDrivers.find((driver: any) => driverId === driver.personId))
                .filter((driver: any) => driver !== undefined);
        }
    }

    public async componentDidMount() {
        this.fetchLookupValues("mileage");
    }

    public render() {
        const {vehicleIndex} = this.props;

        return (

            <div className="quote-summary-panel">
                <div className="padding-32">
                    <div className="d-flex d-md-none align-i-center w-100 table-section-title">
                        <img className="mb-0 car-panel-icon"
                             src={`/${resourcesHelper.THEME_PATH}/img/car-cover.svg`}
                             alt="Cover icon" aria-label="Cover icon"/>
                        <h4 className="font-family-display font-weight-bold m-0">Policy details</h4>
                    </div>
                    <div className="d-flex flex-row w-100">
                        <div className="d-none d-md-flex flex-column">
                            <img className="mb-0 car-panel-icon"
                                 src={`/${resourcesHelper.THEME_PATH}/img/car-cover.svg`}
                                 alt="Cover icon" aria-label="Cover icon"/>
                        </div>
                        <div className="d-flex flex-column">
                            <h4 className="d-none d-md-flex font-family-display font-weight-bold m-0">Policy details</h4>
                            {this.renderCoverDetails(vehicleIndex)}
                        </div>
                    </div>
                </div>
                <hr className="w-100 annual-motor-separator"/>
                <div className="car-info">
                    <div className="padding-32">
                        <div className="d-flex d-md-none align-i-center w-100 table-section-title">
                            <img className="mb-0 car-panel-icon"
                                 src={`/${resourcesHelper.THEME_PATH}/img/car-icon-panel.svg`}
                                 alt="Vehicle icon"/>
                            <h4 className="font-family-display font-weight-bold mb-0">Car details</h4>
                        </div>
                        <div className="d-flex flex-row w-100">
                            <div className="d-none d-md-flex flex-column">
                                <img className="mb-0 car-panel-icon"
                                     src={`/${resourcesHelper.THEME_PATH}/img/car-icon-panel.svg`}
                                     alt="Vehicle icon"/>
                            </div>
                            <div className="d-flex flex-column">
                                <h4 className="d-none d-md-flex font-family-display font-weight-bold mb-0">Car details</h4>
                                {this.renderCarDetails()}
                            </div>
                        </div>
                    </div>
                </div>
                <hr className="w-100 annual-motor-separator"/>
                <div className="drivers-details">
                    <div className="padding-32">
                        <div className="d-flex d-md-none align-i-center w-100 table-section-title">
                            <img className="mb-0 car-panel-icon" src={`/${resourcesHelper.THEME_PATH}/img/drivers.svg`} alt="Driver icon"/>
                            <h4 className="font-family-display font-weight-bold mb-0">Driver(s) details</h4>
                        </div>
                        <div className="d-flex flex-row w-100">
                            <div className="d-none d-md-flex flex-column">
                                <img className="mb-0 car-panel-icon" src={`/${resourcesHelper.THEME_PATH}/img/drivers.svg`} alt="Driver icon"/>
                            </div>
                            <div className="d-flex flex-column">
                                <div>
                                    <h4 className="d-none d-md-flex font-family-display font-weight-bold mb-0">Driver(s) details</h4>
                                    {this.renderDriverDetailSections()}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <hr className="w-100 annual-motor-separator"/>
                <div className="section-summery">
                    <div className="padding-32">
                        <div className="d-flex d-md-none align-i-center w-100 table-section-title">
                            <img className="mb-0 car-panel-icon" src={`/${resourcesHelper.THEME_PATH}/img/documents.svg`} alt="Documents icon"/>
                            <h4 className="font-family-display font-weight-bold mb-0">Policy documents</h4>
                        </div>
                        <div className="d-flex flex-row w-100">
                            <div className="d-none d-md-flex flex-column">
                                <img className="mb-0 car-panel-icon" src={`/${resourcesHelper.THEME_PATH}/img/documents.svg`} alt="Documents icon"/>
                            </div>
                            <div className="d-flex flex-column">
                                <div>
                                    <h4 className="d-none d-md-flex font-family-display font-weight-bold mb-0">Policy documents</h4>
                                    <div className="mt-3">
                                        {this.renderDocumentDetailsSection()}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    private renderCoverDetails(vehicleIndex: number) {
        return (
            <ul className="list-unstyled mb-0">
                <li>
                    <p id={`vehicle${vehicleIndex}-startDate`}>
                        <span className="font-weight-bold">Cover start date: </span>
                        {this.renderPolicyStartDate(this.policyToRender)}
                    </p>
                </li>
                <li>
                    <p id={`vehicle${vehicleIndex}-endDate`}>
                        <span className="font-weight-bold">Cover expiry date: </span>
                        {formatDate(this.policyToRender.endDate, "DD MMM YYYY, HH:mm")}
                    </p>
                </li>
                <li>
                    <p><span className="font-weight-bold">Cover type: </span>Comprehensive</p>
                </li>
            </ul>
        );
    }

    private renderCarDetails() {
        const vehicleExcesses: any = this.policyToRender.interaction.vehicles[0].annualVehicleExcess;
        const vehicleFuelTypeActual = getInteractionVehicleFuelType(this.vehicleToRender.fuelType, this.vehicleToRender.fuelTypeFull);
        return this.vehicles.map((vehicle: any, index: number) => (
            <React.Fragment key={index}>
                <div className="car-subject">
                    <div className="font-family-display font-weight-bold car-subject-title mb-3">{`${this.vehicleToRender.make}, ${this.vehicleToRender.model}`}</div>
                    <div className="number-plate-preview mb-3">{this.vehicleToRender.registrationNumber}</div>
                    <div>{`${getVehicleEngineSize(vehicle)}CC, ${getVehicleNumberOfDoors(vehicle)} dr, ${resolveTransmission(this.vehicleToRender.transmission)}, ${resolveFuelType(vehicleFuelTypeActual)}`}</div>
                    <div>{`Manufactured in ${this.vehicleToRender.year}`}</div>
                    <div>{`Purchased in ${convertDate(this.vehicleToRender.purchaseDate , "MMM YYYY")}`}</div>
                    {this.renderMotorDetailsSection()}
                </div>
                <div className="excesses">
                    <div className="excesses-title mb-3">Excesses that apply</div>
                    <div className="mb-3">
                        <div>Accidental damage: <strong>{CommonHelpers.getAmountWithoutDecimalDigits(vehicleExcesses.compulsoryExcess)}</strong></div>
                        <div>Fire or theft: <strong>{CommonHelpers.getAmountWithoutDecimalDigits(vehicleExcesses.compulsoryExcess)}</strong></div>
                    </div>
                    <div className="mb-3">
                        <span>Your total excess applies every time you claim and to every car you’re claiming on.</span>
                    </div>
                    <div className="mb-3">
                        <div className="font-weight-bold">Glass-only excess costs you less</div>
                        <div>Glass repair excess: just <strong>{CommonHelpers.getAmountWithoutDecimalDigits(vehicleExcesses.windscreenRepairExcess)}</strong></div>
                        <div>Glass replacement excess: just <strong>{CommonHelpers.getAmountWithoutDecimalDigits(vehicleExcesses.windscreenReplacementExcess)}</strong> </div>
                    </div>
                    <div>
                        <div className="font-weight-bold">Non-recommended repairer excess costs you more</div>
                        <div>Non-recommended repairer excess: <strong>{CommonHelpers.getAmountWithoutDecimalDigits(vehicleExcesses.nonRecommendedRepairerExcess)}</strong></div>
                        This is in addition to the excesses shown above if you choose a
                        repairer <strong>not</strong> on our list of
                        recommended repairers.<br/>
                        This also applies to glass replacement but <strong>not</strong> glass-only repairs.
                    </div>
                </div>
                <div className="vehicle-drivers">
                    <div className="drivers-title mb-3">Drivers</div>
                    {this.renderVehicleDrivers()}
                </div>
            </React.Fragment>
        ));
    }

    private renderVehicleDrivers() {
        return this.vehicleDrivers.map((driver: any, index: number) => {
            return (
                <div key={index} className="detail-value">
                    {`${driver.firstName} ${driver.lastName}`} {driver.personId === this.vehicleToRender.mainDriverId &&
                    <span>(main driver)</span>}
                </div>
            );
        });
    }

    private renderMotorDetailsSection() {
        return this.vehicles.map((vehicle: any, index: number) => {

            return (
                <div key={index}>
                    <ul className="list-unstyled mb-0">
                        <li>
                            <p><span className="font-weight-bold">Annual mileage:</span> {this.resolveLookupValue("mileage", this.vehicleToRender.mileage.toString())}</p>
                        </li>
                        <li>
                            <p><span className="font-weight-bold">Postcode where the car is kept:</span> {this.vehicleToRender.overnightLocationPostcode}</p>
                        </li>
                        <li>
                            <p><span className="font-weight-bold">Car usage:</span> {this.fetchLookupValue("carUsage", this.vehicleToRender.classOfUse)}</p>
                        </li>
                    </ul>
                </div>
            )
                ;
        });
    }

    private renderDriverDetailSections() {
        return this.vehicleDrivers.map((driver: any, index: number) => (
            <div key={index} className="section driver-details">
                <div className="section-contents">
                    {this.renderDriverDetails(driver, index)}
                </div>
            </div>
        ));
    }

    private renderDriverDetails(driver: any, index: number) {
        const isPolicyHolder: boolean = driver.personId === this.policyToRender.interaction.policyHolder.personId

        return (
            <ul key={index} className="drivers-section-spaceing list-unstyled">
                <li>
                    <p className="font-weight-bold mr-1">{`${driver.firstName} ${driver.lastName}`}</p>
                </li>
                <li>
                    <p><span className="font-weight-bold">Date of birth:</span> {moment(driver.dateOfBirth, moment.ISO_8601).format("D MMMM YYYY")}</p>
                </li>
                {(driver.drivingLicenceHandy && driver.dlnLookupData.dlnLookupCallSucess) && <li>
                    <p className="detail-key"><span className="font-weight-bold">Driving licence type:</span>{driver.licence.type}</p>
                </li>}
                <li>
                    <p><span className="font-weight-bold">Claims in the last 5 years:</span> {this.renderClaims(driver)}</p>
                </li>
                <li>
                    <p><span className="font-weight-bold">Criminal convictions:</span> {CommonHelpers.booleanToText(driver.hasUnspentCriminalConvictions, "Yes", "None")}</p>
                </li>
                {this.renderMotoringConvictions(driver)}
                {isPolicyHolder && this.renderPolicyHolderDetails(driver)}
            </ul>
        );
    }

    private renderPolicyHolderDetails(driver: any) {
        const party = this.policyToRender.policyHolder;

        return (
            <React.Fragment>
                <li>
                    <p><span className="font-weight-bold">Address:</span> {driver.address.fullAddress}</p>
                </li>
                <li>
                    <p><span className="font-weight-bold">Email:</span> {party.email}</p>
                </li>
            </React.Fragment>
        );
    }

    private renderPolicyStartDate(policy: any) {
        const startMoment = moment(policy.startDate, moment.ISO_8601);
        const utcTime = moment.utc(policy.startDate, moment.ISO_8601).format('HH:mm');

        if (utcTime === '00:00') {
            const date = startMoment.format('DD MMM YYYY');
            const time = this.props.isOldPolicy ? '00:00' : '00:01';
            return `${date}, ${time}`;
        }
        return startMoment.format('DD MMM YYYY, HH:mm');
    }

    private renderClaims(driver: any) {
        if (driver.hasClaims && driver.numberOfClaims > 0 && driver.claims?.length > 0) {
            return driver.claims.map((claim: any, index: any) =>
                <span key={index}>{resolveClaimType(claim.claimType)}, {formatDate(claim.date, "MMM YYYY")}</span>
            )
        } else {
            return <span>None</span>
        }
    }

    private renderMotoringConvictions(driver: any): React.ReactNode {
        if (driver?.dlnLookupData?.dlnLookupCallSucess) {
            return (
                <li>
                    <p><span className="font-weight-bold">Motoring convictions:</span> As per your DVLA records</p>
                </li>
            );
        } else {
            return (
                <li>
                    <p><span className="font-weight-bold">Motoring convictions:</span> {this.renderConvictionDetails(driver)}</p>
                </li>
            )
        }
    }

    private renderConvictionDetails(driver: any) {
        if (driver.hasConvictions && driver.convictions?.length > 0) {
            return driver.convictions.map((conviction: any, index: any) => (
                <span key={index}>
                    {`${conviction.convictionCode}, ${formatDate(conviction.convictionDate, "MMM YYYY")}`}
                </span>
            ))
        } else {
            return <span>None</span>
        }
    }

    private renderDocumentDetailsSection() {
        const ipidVersion: string | null = documentHelper.getDocumentVersionByDateAndType(new Date(this.policyToRender.interaction.factors.originalQuoteDate), DocTypeEnum.DRIVE_AWAY_IPID);
        const doiVersion: string | null = documentHelper.getDocumentVersionByDateAndType(new Date(this.policyToRender.interaction.factors.originalQuoteDate), DocTypeEnum.DRIVE_AWAY_DOI);

        return (
            <ul className="list-unstyled">
                <li className="mb3">
                    <a className="btn btn-text d-flex text-align-left align-i-center documents-list-item"
                       target="_blank"
                       download="5-Day Drive Away Insurance Product Information Document (IPID)"
                       href={`/resources/documents/${resourcesHelper.THEME}/${ipidVersion}/${resourcesHelper.THEME}_DriveAway_IPID.pdf`}
                    ><span className="file-icon"/>5-Day Drive Away Insurance Product Information Document (IPID)</a>
                </li>
                <li className="mb3">
                    <a className="btn btn-text d-flex text-align-left align-i-center documents-list-item"
                       target="_blank"
                       download="5-Day Drive Away Car Document of Insurance (DOI)"
                       href={`/resources/documents/${resourcesHelper.THEME}/${doiVersion}/${resourcesHelper.THEME}_DriveAway_DOI.pdf`}
                    ><span className="file-icon"/>5-Day Drive Away Car Document of Insurance (DOI)</a>
                </li>
                <li className="mb3">
                    <a className="btn btn-text d-flex text-align-left align-i-center documents-list-item" target="_blank"
                       download="How we use your personal information"
                       href={CAR_PIU_PDF_PATH}
                    ><span className="file-icon"/>How we use your personal information</a>
                </li>
            </ul>
        );
    }

    private fetchLookupValue(fieldId: string, id: string): string {
        let value: string = "";

        this.lookupService.fetchLookupValues(fieldId, "en-UK").subscribe((lookupValues: ListItem[]) => {
            value = Object.values(lookupValues).filter(entry => entry.id === id)[0].value;
        });

        return value;
    }

    private fetchLookupValues(lookupName: string) {
        this.lookupService.fetchLookupValues(lookupName, "en-UK").subscribe((lookupValues: ListItem[]) => {
            this.setState(prevState => ({
                lookup: {
                    ...prevState.lookup,
                    [lookupName]: lookupValues
                }
            }));
        }, () => {
            throw new Error(`Error: failed to fetch lookup values for '${lookupName}' lookup`);
        });
    }

    private resolveLookupValue(lookupName: string, lookupId: string): string {
        if (!lookupId || !this.state?.lookup[lookupName]) {
            return "";
        }
        const listItem: ListItem | undefined = this.state.lookup[lookupName].find((lItem: ListItem) => `${lItem.id}` === `${lookupId}`);
        if (!listItem) {
            throw new Error(`Error: no item with id '${lookupId}' found in lookup '${lookupName}'`);
        }
        return listItem.value;
    }
}
